import t from "./td-longtail-vue-components101.js";
/* empty css                              */
import e from "./td-longtail-vue-components98.js";
var _ = function() {
  var s = this, a = s._self._c, r = s._self._setupProxy;
  return s.text ? a("p", { staticClass: "paragraph", class: r.classes, domProps: { innerHTML: s._s(s.text) } }) : a("p", { staticClass: "paragraph", class: r.classes }, [s._t("default")], 2);
}, n = [], o = /* @__PURE__ */ e(
  t,
  _,
  n,
  !1,
  null,
  "7d131964"
);
const i = o.exports;
export {
  i as default
};
